import { Injectable, inject } from '@angular/core';
import { SupabaseService } from './supabase.service';

export interface SendRegistrationSmsCodeResult {
  success: boolean;
  expires_in_seconds?: number;
  resend_after_seconds?: number;
  error?: string;
}

export interface VerifyRegistrationSmsCodeResult {
  success: boolean;
  attempts_remaining?: number;
  error?: string;
}

@Injectable({ providedIn: 'root' })
export class RegistrationSmsVerificationService {
  private readonly supabase = inject(SupabaseService);

  async sendCode(phone: string): Promise<SendRegistrationSmsCodeResult> {
    const { data, error } = await this.supabase.instance.functions.invoke<SendRegistrationSmsCodeResult>(
      'public-send-registration-sms-code',
      { body: { phone } }
    );

    if (error) {
      throw new Error(await this.getFunctionErrorMessage(error, 'No se pudo enviar el codigo SMS.'));
    }

    if (!data?.success) {
      throw new Error(data?.error || 'No se pudo enviar el codigo SMS.');
    }

    return data;
  }

  async verifyCode(phone: string, code: string): Promise<VerifyRegistrationSmsCodeResult> {
    const { data, error } = await this.supabase.instance.functions.invoke<VerifyRegistrationSmsCodeResult>(
      'public-verify-registration-sms-code',
      { body: { phone, code } }
    );

    if (error) {
      throw new Error(await this.getFunctionErrorMessage(error, 'No se pudo validar el codigo SMS.'));
    }

    if (!data?.success) {
      throw new Error(data?.error || 'No se pudo validar el codigo SMS.');
    }

    return data;
  }

  private async getFunctionErrorMessage(error: unknown, fallbackMessage: string): Promise<string> {
    const context = (error as { context?: unknown }).context;

    if (context instanceof Response) {
      try {
        const payload = await context.clone().json() as { error?: string; message?: string };
        return payload.error || payload.message || fallbackMessage;
      } catch {
        return fallbackMessage;
      }
    }

    return error instanceof Error ? error.message : fallbackMessage;
  }
}
